module.exports = __webpack_public_path__ + "img/BH.c15967da.png";